// https://swiperjs.com/get-started
import SwiperCore, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay]);
import 'swiper/swiper-bundle.css';

document.querySelectorAll('.gallery-top').forEach((el) => {
  new SwiperCore(el, {
    direction: 'horizontal',
    loop: true,
    navigation: {
      nextEl: el.querySelector('.button-next'),
      prevEl: el.querySelector('.button-prev'),
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      type: 'fraction',
    },
  });
});

document.querySelectorAll('.swiper-quotes').forEach((el) => {
  const slides = el.querySelectorAll('.swiper-slide').length;
  if (slides < 2) {
    return;
  }

  new SwiperCore(el, {
    direction: 'horizontal',
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: el.querySelector('.button-next'),
      prevEl: el.querySelector('.button-prev'),
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      type: 'fraction',
    },
  });
});
